module.exports = __webpack_public_path__ + "img/banner-poster-Sp.8fbf0823.png";